import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M8 16.25H18C18.6904 16.25 19.25 15.6904 19.25 15V6C19.25 5.30964 18.6904 4.75 18 4.75H6C5.30964 4.75 4.75 5.30964 4.75 6V16.25V18.6596C4.75 19.1225 5.32471 19.3369 5.62784 18.9871L8 16.25ZM8 16.25V15C8 13.8954 8.89543 13 10 13H14C15.1046 13 16 13.8954 16 15V16.25" />
		<Path d="M13.75 9C13.75 9.9665 12.9665 10.75 12 10.75C11.0335 10.75 10.25 9.9665 10.25 9C10.25 8.0335 11.0335 7.25 12 7.25C12.9665 7.25 13.75 8.0335 13.75 9Z" />
	</SVG>
);
